import {DomainStore} from 'shared/store';
import {action, computed, observable} from 'mobx';
import _ from 'lodash';

class AssigneeSelectorMenuState {
  store = new DomainStore();
  onChange;

  @observable annotation;
  @observable position = {};
  @observable assignee = {
    assigneeType: 'employee',
    employee: null
  };
  @observable selectedFieldType;

  @observable employees = [];

  receiveProps({assignee, onChange, position, selectedFieldType, isOpen, employees}) {
    if (!isOpen) return;

    this.position = position;
    this.selectedFieldType = selectedFieldType;
    this.onChange = onChange;
    this.employees = employees;

    if (assignee === 'manager') {
      this.assignee = {
        assigneeType: 'manager'
      };
    } else if (!assignee) {
      this.assignee = {
        assigneeType: 'employee'
      };
    } else if (assignee) {
      this.assignee = {
        assigneeType: 'specific_employee',
        employee: {
          id: assignee
        }
      }
    }
  }

  @action updateAssignee(assignee) {
    _.merge(this.assignee, assignee);

    if (this.isSpecificEmployee && !this.assignee.employee) return;

    this.onChange(this.assignee);
  }

  @computed get isSpecificEmployee() {
    return this.assignee.assigneeType === 'specific_employee';
  }

  @computed get selectorLabel() {
    if (this.selectedFieldType === 'mergeField') {
      return 'company_settings.documents.Which signer is this for?'
    } else {
      return 'company_settings.documents.Who should complete this?'
    }
  }
}

export default AssigneeSelectorMenuState;
